import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, vModelText as _vModelText, vModelSelect as _vModelSelect, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0026e6d9")

_pushScopeId("data-v-0026e6d9")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新規スクールを登録")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_5 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_6 = {
  key: 1,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "契約区分", -1)
const _hoisted_8 = { class: "p-4 bg-primary-100 rounded-md mb-4" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "paid-subscription",
  class: "pl-2 cursor-pointer font-medium"
}, "有料", -1)
const _hoisted_11 = {
  key: 0,
  class: "mt-3 ml-6 p-3 bg-white rounded-md"
}
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "p-4 bg-primary-100 rounded-md mb-4" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  for: "free-subscription",
  class: "pl-2 cursor-pointer font-medium"
}, "無料", -1)
const _hoisted_16 = {
  key: 0,
  class: "mt-3 ml-6 p-3 bg-white rounded-md"
}
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", {
  for: "other-subscription",
  class: "pl-2 cursor-pointer font-medium"
}, "その他", -1)
const _hoisted_21 = {
  key: 2,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "都道府県", -1)
const _hoisted_23 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_24 = { class: "flex flex-wrap gap-2" }
const _hoisted_25 = {
  key: 3,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "学校区分", -1)
const _hoisted_27 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_28 = {
  key: 4,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "セグメント（複数選択可・任意）", -1)
const _hoisted_30 = {
  key: 0,
  class: "p-4 bg-primary-100 rounded-md grid grid-cols-2 gap-2"
}
const _hoisted_31 = {
  key: 1,
  class: "p-4 bg-primary-100 rounded-md text-sm text-gray-600"
}
const _hoisted_32 = {
  key: 5,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "設立主体区分", -1)
const _hoisted_34 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_35 = {
  key: 6,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "ユーザー契約範囲", -1)
const _hoisted_37 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_38 = {
  key: 7,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "役割", -1)
const _hoisted_40 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_41 = /*#__PURE__*/_createVNode("label", {
  for: "add-role",
  class: "pl-2 cursor-pointer"
}, " 役割を追加する ", -1)
const _hoisted_42 = { class: "ml-6" }
const _hoisted_43 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_44 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, [
  /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "生徒用帳票を表示しない")
], -1)
const _hoisted_45 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_46 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_47 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, [
  /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "生徒のログインパスワード変更を可能にする")
], -1)
const _hoisted_48 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_49 = {
  key: 8,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, [
  /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "みんがく学習室を表示しない")
], -1)
const _hoisted_51 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_52 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_53 = {
  key: 0,
  class: "leading-7 text-sm text-gray-600"
}
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "スクールAIの機能のみを利用する", -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_56 = {
  key: 1,
  class: "leading-7 text-sm text-gray-600"
}
const _hoisted_57 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_58 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_59 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " スクールAI上でプロンプトの作成を禁止する ", -1)
const _hoisted_60 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_61 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_62 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " 生徒プロンプト作成を禁止する ", -1)
const _hoisted_63 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_64 = {
  key: 9,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " 学習カードの利用を許可する ", -1)
const _hoisted_66 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_67 = {
  key: 10,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " スクール管理者にスタッフのチャット閲覧を可能にする ", -1)
const _hoisted_69 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_70 = { class: "flex flex-col items-center w-3/4 mx-auto" }
const _hoisted_71 = /*#__PURE__*/_createVNode("label", {
  for: "tutors",
  class: "leading-7 text-sm text-gray-600 w-full"
}, " 先生 ", -1)
const _hoisted_72 = { class: "flex w-full items-end mb-4" }
const _hoisted_73 = { class: "w-1/2 mr-2" }
const _hoisted_74 = /*#__PURE__*/_createVNode("label", {
  for: "tutorName",
  class: "leading-7 text-sm text-gray-500"
}, " 名前 ", -1)
const _hoisted_75 = {
  key: 0,
  class: "mt-1 text-red-500 text-xs"
}
const _hoisted_76 = {
  key: 1,
  class: "h-5"
}
const _hoisted_77 = { class: "w-1/2 ml-2" }
const _hoisted_78 = /*#__PURE__*/_createVNode("label", {
  for: "tutorName",
  class: "leading-7 text-sm text-gray-500"
}, " 権限 ", -1)
const _hoisted_79 = { class: "relative transition-all duration-300 hover:text-primary-500" }
const _hoisted_80 = /*#__PURE__*/_createVNode("option", { disabled: "" }, "権限を選択", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("span", { class: "absolute right-2 top-0 h-full w-6 text-center pointer-events-none flex items-center justify-center text-primary-500" }, [
  /*#__PURE__*/_createVNode("svg", {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    class: "w-4 h-4",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "M6 9l6 6 6-6" })
  ])
], -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("div", { class: "h-5" }, null, -1)
const _hoisted_83 = { class: "flex w-full items-end mb-4" }
const _hoisted_84 = { class: "w-1/2 mr-2" }
const _hoisted_85 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "leading-7 text-sm text-gray-500"
}, " メールアドレス (重複不可) ", -1)
const _hoisted_86 = {
  key: 0,
  class: "mt-1 text-red-500 text-xs"
}
const _hoisted_87 = {
  key: 1,
  class: "h-5"
}
const _hoisted_88 = { class: "w-1/2 ml-2" }
const _hoisted_89 = /*#__PURE__*/_createVNode("label", {
  for: "password",
  class: "leading-7 text-sm text-gray-500"
}, " 初期パスワード ", -1)
const _hoisted_90 = {
  key: 0,
  class: "mt-1 text-red-500 text-xs"
}
const _hoisted_91 = {
  key: 1,
  class: "h-5"
}
const _hoisted_92 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "4",
  class: "w-4 h-4 mr-2",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M12 6v6m0 0v6m0-6h6m-6 0H6" })
], -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("span", null, "先生を追加", -1)
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" 導入スクールを登録 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "スクールID (重複不可)",
          name: "id",
          type: "text",
          placeholder: "6桁の半角数字",
          value: _ctx.schoolId,
          invalid: !_ctx.validId,
          "invalid-message": "スクールIDは6桁の半角数字で入力してください。また他のスクールと同じIDは使用できません。",
          entered: "",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.schoolId = $event))
        }, null, 8, ["value", "invalid"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_text_field, {
          label: "スクール名称",
          name: "name",
          type: "text",
          placeholder: "例）みんがくスクール",
          value: _ctx.schoolName,
          invalid: !_ctx.validName,
          "invalid-message": "スクール名称は入力必須です",
          entered: _ctx.enteredSchoolName,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.schoolName = $event)),
          onEnter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.enteredSchoolName = true))
        }, null, 8, ["value", "invalid", "entered"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_m_select_box, {
          key: "ref.id",
          label: "スクール領域",
          name: "target",
          placeholder: "スクール領域を選択",
          options: _ctx.targets,
          value: _ctx.selectedTargetId,
          "value-key": "ref.id",
          "text-key": "data.name",
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedTargetId = $event))
        }, null, 8, ["options", "value"])
      ]),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_m_text_field, {
              label: "スクールAI利用期限日",
              name: "schoolAiUsageExpiresAtDate",
              type: "date",
              placeholder: "未設定の場合は制限なし",
              value: _ctx.schoolAiUsageExpiresAtDate,
              onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.schoolAiUsageExpiresAtDate = $event))
            }, null, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("input", {
                  id: "paid-subscription",
                  checked: _ctx.isPaidSubscription,
                  type: "checkbox",
                  name: "paid-subscription",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSubscriptionCheck('paid')))
                }, null, 40, ["checked"]),
                _hoisted_10
              ]),
              (_ctx.isPaidSubscription)
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode(_component_m_text_field, {
                        label: "契約開始日",
                        name: "paidSubscriptionStartDay",
                        type: "date",
                        placeholder: "2024/04/01",
                        value: _ctx.paidSubscriptionStartDay,
                        onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.paidSubscriptionStartDay = $event))
                      }, null, 8, ["value"])
                    ]),
                    _createVNode(_component_m_text_field, {
                      label: "契約終了日",
                      name: "paidSubscriptionEndDay",
                      type: "date",
                      placeholder: "2025/03/31",
                      value: _ctx.paidSubscriptionEndDay,
                      onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.paidSubscriptionEndDay = $event))
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("input", {
                  id: "free-subscription",
                  checked: _ctx.isFreeSubscription,
                  type: "checkbox",
                  name: "free-subscription",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSubscriptionCheck('free')))
                }, null, 40, ["checked"]),
                _hoisted_15
              ]),
              (_ctx.isFreeSubscription)
                ? (_openBlock(), _createBlock("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode(_component_m_text_field, {
                        label: "契約開始日",
                        name: "freeSubscriptionStartDay",
                        type: "date",
                        placeholder: "2024/04/01",
                        value: _ctx.freeSubscriptionStartDay,
                        onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.freeSubscriptionStartDay = $event))
                      }, null, 8, ["value"])
                    ]),
                    _createVNode(_component_m_text_field, {
                      label: "契約終了日",
                      name: "freeSubscriptionEndDay",
                      type: "date",
                      placeholder: "2025/03/31",
                      value: _ctx.freeSubscriptionEndDay,
                      onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.freeSubscriptionEndDay = $event))
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("input", {
                  id: "other-subscription",
                  checked: _ctx.isOtherSubscription,
                  type: "checkbox",
                  name: "other-subscription",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onSubscriptionCheck('other')))
                }, null, 40, ["checked"]),
                _hoisted_20
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_21, [
            _hoisted_22,
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PREFECTURES, (p) => {
                  return (_openBlock(), _createBlock("button", {
                    key: p,
                    type: "button",
                    class: [
                'border rounded px-2 py-1 text-sm transition-colors',
                _ctx.prefecture === p
                  ? 'bg-primary-500 text-white border-primary-500'
                  : 'bg-white border-gray-300 hover:border-primary-500'
              ],
                    onClick: ($event: any) => (_ctx.prefecture = _ctx.prefecture === p ? null : p)
                  }, _toDisplayString(p), 11, ["onClick"]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_25, [
            _hoisted_26,
            _createVNode("div", _hoisted_27, [
              _createVNode(_component_m_select_box, {
                name: "schoolCategory",
                options: _ctx.schoolCategoryOptions,
                value: _ctx.schoolCategory ?? '',
                "value-key": "key",
                "text-key": "name",
                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.schoolCategory = $event || null))
              }, null, 8, ["options", "value"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSuperAdmin && _ctx.isSegmentSelectableTarget)
        ? (_openBlock(), _createBlock("div", _hoisted_28, [
            _hoisted_29,
            (_ctx.selectableSegments.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_30, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectableSegments, (segment) => {
                    return (_openBlock(), _createBlock("label", {
                      key: segment.id,
                      class: "flex items-center gap-2 cursor-pointer"
                    }, [
                      _createVNode("input", {
                        type: "checkbox",
                        checked: _ctx.segmentIds.includes(segment.id),
                        onChange: ($event: any) => (_ctx.toggleSegment(segment.id))
                      }, null, 40, ["checked", "onChange"]),
                      _createVNode("span", null, _toDisplayString(segment.title), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("p", _hoisted_31, " このスクール領域向けのセグメントはまだ登録されていません。 "))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_32, [
            _hoisted_33,
            _createVNode("div", _hoisted_34, [
              _createVNode(_component_m_select_box, {
                name: "foundingBody",
                options: _ctx.foundingBodyOptions,
                value: _ctx.foundingBody ?? '',
                "value-key": "key",
                "text-key": "name",
                onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.foundingBody = $event || null))
              }, null, 8, ["options", "value"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_35, [
            _hoisted_36,
            _createVNode("div", _hoisted_37, [
              _createVNode(_component_m_select_box, {
                name: "userContractScope",
                options: _ctx.userContractScopeOptions,
                value: _ctx.userContractScope ?? '',
                "value-key": "key",
                "text-key": "name",
                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.userContractScope = $event || null))
              }, null, 8, ["options", "value"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_38, [
            _hoisted_39,
            _createVNode("div", _hoisted_40, [
              _withDirectives(_createVNode("input", {
                id: "add-role",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.addRole = $event)),
                type: "checkbox",
                name: "add-role",
                class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
              }, null, 512), [
                [_vModelCheckbox, _ctx.addRole]
              ]),
              _hoisted_41,
              _withDirectives(_createVNode("div", _hoisted_42, [
                _createVNode(_component_m_select_box, {
                  key: "key",
                  name: "role",
                  placeholder: "役割を選択",
                  options: [
                {
                  key: 'serviceProvider',
                  name: `${
                    _ctx.isSelectedTargetSchool ? '教育委員会' : 'サービス管理人'
                  }`
                }
              ],
                  value: _ctx.role[0],
                  "value-key": "key",
                  "text-key": "name",
                  onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.role[0] = $event))
                }, null, 8, ["options", "value"])
              ], 512), [
                [_vShow, _ctx.addRole]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_43, [
        _hoisted_44,
        _createVNode("div", _hoisted_45, [
          _withDirectives(_createVNode("input", {
            id: "display-login-invitation",
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.hideLoginInvitaion = $event)),
            type: "checkbox",
            name: "display-login-invitation",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
          }, null, 512), [
            [_vModelCheckbox, _ctx.hideLoginInvitaion]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_46, [
        _hoisted_47,
        _createVNode("div", _hoisted_48, [
          _withDirectives(_createVNode("input", {
            id: "display-login-invitation",
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.allowStudentsToChangePassword = $event)),
            type: "checkbox",
            name: "display-login-invitation",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
          }, null, 512), [
            [_vModelCheckbox, _ctx.allowStudentsToChangePassword]
          ])
        ])
      ]),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_49, [
            _hoisted_50,
            _createVNode("div", _hoisted_51, [
              _withDirectives(_createVNode("input", {
                id: "display-login-invitation",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.hideMingakuStudyRoom = $event)),
                type: "checkbox",
                name: "display-login-invitation",
                class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
              }, null, 512), [
                [_vModelCheckbox, _ctx.hideMingakuStudyRoom]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_52, [
        (_ctx.isServiceProvider)
          ? (_openBlock(), _createBlock("p", _hoisted_53, [
              _hoisted_54,
              _hoisted_55,
              _createTextVNode(" " + _toDisplayString(`※${
              _ctx.isSchool ? "教育委員会" : "サービス管理人"
            }は編集することができません。変更の希望がある場合はみんがくまでお問い合わせください。`), 1)
            ]))
          : (_openBlock(), _createBlock("p", _hoisted_56, " スクールAIの機能のみを利用する ")),
        _createVNode("div", _hoisted_57, [
          _withDirectives(_createVNode("input", {
            id: "use-school-ai-exclusively",
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.useSchoolAiExclusively = $event)),
            type: "checkbox",
            name: "add-role",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
            disabled: _ctx.isServiceProvider ? true : false
          }, null, 8, ["disabled"]), [
            [_vModelCheckbox, _ctx.useSchoolAiExclusively]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_58, [
        _hoisted_59,
        _createVNode("div", _hoisted_60, [
          _withDirectives(_createVNode("input", {
            id: "is-prompt-creation-forbidden",
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.isPromptCreationForbidden = $event)),
            type: "checkbox",
            name: "is-prompt-creation-forbidden",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
          }, null, 512), [
            [_vModelCheckbox, _ctx.isPromptCreationForbidden]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_61, [
        _hoisted_62,
        _createVNode("div", _hoisted_63, [
          _withDirectives(_createVNode("input", {
            id: "allow-students-to-create-prompts",
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.disableStudentsPromptCreation = $event)),
            type: "checkbox",
            name: "allow-students-to-create-prompts",
            class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
          }, null, 512), [
            [_vModelCheckbox, _ctx.disableStudentsPromptCreation]
          ])
        ])
      ]),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_64, [
            _hoisted_65,
            _createVNode("div", _hoisted_66, [
              _withDirectives(_createVNode("input", {
                id: "can-use-learning-card",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.canUseLearningCard = $event)),
                type: "checkbox",
                name: "can-use-learning-card",
                class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
              }, null, 512), [
                [_vModelCheckbox, _ctx.canUseLearningCard]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_67, [
            _hoisted_68,
            _createVNode("div", _hoisted_69, [
              _withDirectives(_createVNode("input", {
                id: "display-login-invitation",
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.canOwnerViewOtherStaffChats = $event)),
                type: "checkbox",
                name: "display-login-invitation",
                class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
              }, null, 512), [
                [_vModelCheckbox, _ctx.canOwnerViewOtherStaffChats]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_70, [
        _hoisted_71,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tutors, (tutor, i) => {
          return (_openBlock(), _createBlock("div", {
            key: i,
            class: "flex flex-col w-full rounded-md border-2 border-gray-200 px-3 py-2 mb-4"
          }, [
            _createVNode("div", _hoisted_72, [
              _createVNode("div", _hoisted_73, [
                _hoisted_74,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": ($event: any) => (tutor.name = $event),
                  type: "text",
                  name: "tutorName",
                  placeholder: "皆学太郎",
                  class: ["w-full border-b-2 focus:border-primary-500 text-base outline-none text-gray-700 pb-1 px-3 leading-8 transition-colors duration-300", {
                  'border-gray-200':
                    tutor.name.length > 0 || !_ctx.enteredNameOfTutors[i],
                  'border-red-500': !tutor.name && _ctx.enteredNameOfTutors[i]
                }],
                  onBlur: ($event: any) => (_ctx.enteredNameOfTutors[i] = true)
                }, null, 42, ["onUpdate:modelValue", "onBlur"]), [
                  [_vModelText, tutor.name]
                ]),
                (!tutor.name && _ctx.enteredNameOfTutors[i])
                  ? (_openBlock(), _createBlock("p", _hoisted_75, " 名前は入力必須です "))
                  : (_openBlock(), _createBlock("div", _hoisted_76))
              ]),
              _createVNode("div", _hoisted_77, [
                _hoisted_78,
                _createVNode("div", _hoisted_79, [
                  _withDirectives(_createVNode("select", {
                    "onUpdate:modelValue": ($event: any) => (tutor.authority = $event),
                    class: "w-full border-b-2 border-gray-200 appearance-none pt-1 pb-2 px-3 focus:outline-none hover:border-primary-600 cursor-pointer"
                  }, [
                    _hoisted_80,
                    _createVNode("option", {
                      value: "owner",
                      selected: tutor.authority == 'owner'
                    }, _toDisplayString(_ctx.isSelectedTargetSchool ? "管理職" : " オーナー"), 9, ["selected"]),
                    _createVNode("option", {
                      value: "admin",
                      selected: tutor.authority == 'admin'
                    }, _toDisplayString(_ctx.isSelectedTargetSchool ? "ICT担当者" : "管理者"), 9, ["selected"]),
                    (!_ctx.isSelectedTargetSchool)
                      ? (_openBlock(), _createBlock("option", {
                          key: 0,
                          value: "general",
                          selected: tutor.authority == 'general'
                        }, " 一般 ", 8, ["selected"]))
                      : _createCommentVNode("", true)
                  ], 8, ["onUpdate:modelValue"]), [
                    [_vModelSelect, tutor.authority]
                  ]),
                  _hoisted_81
                ]),
                _hoisted_82
              ])
            ]),
            _createVNode("div", _hoisted_83, [
              _createVNode("div", _hoisted_84, [
                _hoisted_85,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": ($event: any) => (tutor.email = $event),
                  type: "email",
                  name: "email",
                  placeholder: "tutor@mingaku.net",
                  class: ["w-full border-b-2 focus:border-primary-500 text-base outline-none text-gray-700 pb-1 px-3 leading-8 transition-colors duration-300", {
                  'border-gray-200':
                    _ctx.validEmailOf(tutor.email) || !_ctx.enteredEmailOfTutors[i],
                  'border-red-500':
                    !_ctx.validEmailOf(tutor.email) && _ctx.enteredEmailOfTutors[i]
                }],
                  onBlur: ($event: any) => (_ctx.enteredEmailOfTutors[i] = true)
                }, null, 42, ["onUpdate:modelValue", "onBlur"]), [
                  [_vModelText, tutor.email]
                ]),
                (!_ctx.validEmailOf(tutor.email) && _ctx.enteredEmailOfTutors[i])
                  ? (_openBlock(), _createBlock("p", _hoisted_86, " 正しいメールアドレスを入力してください "))
                  : (_openBlock(), _createBlock("div", _hoisted_87))
              ]),
              _createVNode("div", _hoisted_88, [
                _hoisted_89,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": ($event: any) => (tutor.password = $event),
                  type: "text",
                  name: "password",
                  placeholder: "8文字以上・英字と、数字または記号",
                  class: ["w-full border-b-2 focus:border-primary-500 text-base outline-none text-gray-700 pb-1 px-3 leading-8 transition-colors duration-300", {
                  'border-gray-200': _ctx.validPasswordOf(tutor.password),
                  'border-red-500': !_ctx.validPasswordOf(tutor.password)
                }]
                }, null, 10, ["onUpdate:modelValue"]), [
                  [_vModelText, tutor.password]
                ]),
                (!_ctx.validPasswordOf(tutor.password))
                  ? (_openBlock(), _createBlock("p", _hoisted_90, _toDisplayString(_ctx.passwordMessage), 1))
                  : (_openBlock(), _createBlock("div", _hoisted_91))
              ])
            ])
          ]))
        }), 128)),
        _createVNode("div", {
          class: "flex items-center text-sm rounded-md text-gray-400 font-medium px-4 py-2 border-2 border-gray-200 cursor-pointer transition-colors duration-300 hover:text-primary-500 hover:border-primary-500",
          onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.addTutor && _ctx.addTutor(...args)))
        }, [
          _hoisted_92,
          _hoisted_93
        ])
      ])
    ]),
    footer: _withId(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData && _ctx.allEntered,
        onClick: _ctx.registerSchool
      }, {
        default: _withId(() => [
          _hoisted_94
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
})